import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import { checkUserToken } from "./login/auth";
import { loadProgressBar } from "axios-progress-bar";
// import Loader from "react-loader-spinner";
import { NotificationContainer } from "react-notifications";
import Account from "./components";
import Login from "./login/Login";
import SignUp from "./components/SignUp";
import PaymentReceipt from "./components/PaymentReceipt";
import OnlineRegistration from "./components/OnlineRegistration";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import "react-notifications/lib/notifications.css";
import "axios-progress-bar/dist/nprogress.css";
const keys = require("./config/keys");

loadProgressBar();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentWillMount() {
    await this.props.checkUserToken(
      localStorage.token || localStorage.getItem("token"),
      0
    );
  }
  componentDidUpdate() {}
  render() {
    return (
      <BrowserRouter>
        <div>
          <Header />
          <Route
            exact
            path="/"
            component={
              keys.websiteSetting.signUpContent === "nvu"
                ? SignUp
                : OnlineRegistration
            }
          />
          {keys.websiteSetting.signUpContent !== "nvu" && (
            <Route exact path={"/SignUp"} component={SignUp} />
          )}
          <Route exact path="/Login" component={Login} />
          <Route path="/Account" component={Account} />
          <Route path="/PaymentReceipt" component={PaymentReceipt} />
          <NotificationContainer />
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}
function mapStateToProps({ auth }) {
  return { auth };
}
export default connect(
  mapStateToProps,
  { checkUserToken }
)(App);



// WEBPACK FOOTER //
// ./src/App.js